import { configureStore } from "@reduxjs/toolkit";
import tokensSlice from "../slices/TokensSlice";
import userSlice from "../slices/UserSlice";
import appsSlice, {
  initializeApp,
  setSelectedAgentSiteCode,
  setSelectedAgentName,
} from "../slices/AppsSlice";

export const store = configureStore({
  reducer: {
    tokens: tokensSlice,
    user: userSlice,
    apps: appsSlice,
  },
});

// Restore saved agent context from localStorage
const savedAgentSiteCode = localStorage.getItem("selectedAgentSiteCode");
if (savedAgentSiteCode) {
  store.dispatch(setSelectedAgentSiteCode(savedAgentSiteCode));
}
const savedAgentName = localStorage.getItem("selectedAgentName");
if (savedAgentName) {
  store.dispatch(setSelectedAgentName(savedAgentName));
}

export default store;
